'use client';

import { ModalContainer, ModalKey, useOpenModal } from '@finn/ua-modals';
import { TrackingEventName, useTrackingStore } from '@finn/ua-tracking';
import { useReadyForRetentionDeals } from '@finn/ua-vehicle';
import {
  CookieKeys,
  getClientBooleanCookie,
  setClientBooleanCookie,
} from '@finn/ui-utils';
import { useEffect } from 'react';

import { RetentionModal } from './RetentionModal';

export const RetentionModalPopup = () => {
  const { activeSubscriptions } = useReadyForRetentionDeals();
  const selectedSubscription =
    activeSubscriptions?.length > 0 ? activeSubscriptions[0] : null;
  const selectedSubscriptionId = selectedSubscription?.id;
  const openModal = useOpenModal();
  const track = useTrackingStore((state) => state.track);

  useEffect(() => {
    if (!selectedSubscriptionId) return;
    const isAlreadyShowed = getClientBooleanCookie(
      CookieKeys.RETENTION_POPUP_SHOWED
    );
    if (isAlreadyShowed) return;
    setClientBooleanCookie(CookieKeys.RETENTION_POPUP_SHOWED, true);
    openModal(ModalKey.RETENTION_MODAL_POPUP);
    track(TrackingEventName.MODAL_OPENED, {
      name: 'auto_pop_up_extend_subscription_selector',
    });
  }, [openModal, selectedSubscriptionId, track]);

  return (
    <ModalContainer
      modalKey={ModalKey.RETENTION_MODAL_POPUP}
      ModalComponent={RetentionModal}
      selectedSubscription={selectedSubscription}
      onCloseCallback={() => {
        track(TrackingEventName.MODAL_CLOSED, {
          name: 'auto_pop_up_extend_subscription_selector',
        });
      }}
      autoOpened
    />
  );
};
